import navMenu from "./navMenu";
import btns from "./btns";
import formCtrl from "./formCtrl";
import nation from "./nation";

const SETS = {
  IP: 'https://rd-sde.fgtms.cn',
  basePath: 'fleet',
  PAGE_SIZES: [30, 50, 100, 200],
  ...btns,
  ctrls: formCtrl,
  NATION: nation,
  navMenu,
  getDateStrObj(v) {
    let date = new Date(v)
    const y = date.getFullYear() + ''
    let m = date.getMonth() + 1
    let d = date.getDate()
    m > 9 ? null : m = '0' + m
    d > 9 ? null : d = '0' + d
    return { y, m, d }
  },
  checkLicense(rule, value, callback) {
    const licenseRegExp = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
    if (value == undefined || value == '') {
      callback(new Error('请填写车牌号'));
    } else if (!licenseRegExp.test(value)) {
      callback(new Error('请填写正确的车牌号'));
    } else {
      callback();
    }
  },
  checkPhone(rule, value, callback) {
    const phoneRegExp = /^1[3|4|5|6|7|8|9][0-9]{9}$/
    const fixPhoneRegExp = /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/
    // console.log(rule, value)
    if (value == undefined || value == '') {
      callback(new Error('请填写联系电话'));
    } else if (!phoneRegExp.test(value) && !fixPhoneRegExp.test(value)) {
      callback(new Error('请填写正确的联系电话'));
    } else {
      callback();
    }
  },
}

export default SETS